const UploadTradeOrder = () => import('./order/UploadTradeOrder');
Vue.component('UploadTradeOrder', UploadTradeOrder);

const UploadEdiOrder = () => import('./order/UploadEDIOrder');
Vue.component('UploadEdiOrder', UploadEdiOrder);

const OrderDetailRow = () => import('../../../components/OrderDetailRow');
Vue.component('OrderDetailRow', OrderDetailRow);

const InvoiceDetailRow = () => import('../../../components/InvoiceDetailRow');
Vue.component('InvoiceDetailRow', InvoiceDetailRow);

const DataTable = () => import('../../../components/DataTable');
Vue.component('DataTable', DataTable);
